/* eslint-disable */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { DIMENSION, DIMENSION_NAMES } from '../../plugins/flexboxgrid/config';
import { useTailwind } from '../../hooks';

const ModificatorType = PropTypes.oneOf(DIMENSION_NAMES);

const Row = React.forwardRef((props, ref) => {
  const {
    children,
    className,
    reverse,
    start,
    center,
    end,
    top,
    middle,
    bottom,
    around,
    between,
    first,
    last,
    ...rowProps
  } = props;
  const { theme } = useTailwind();

  const reverseCssClass = useMemo(() => {
    return reverse && 'pff-flexbox-row--reverse';
  }, [reverse]);

  const startCssClass = useMemo(() => {
    if (!start) {
      return '';
    }

    const breakpointWidth = theme.screens[start];
    if (breakpointWidth) {
      if (start === DIMENSION.sm) {
        return 'sm:pff-flexbox-row--start';
      } else if (start === DIMENSION.md) {
        return 'md:pff-flexbox-row--start';
      } else if (start === DIMENSION.lg) {
        return 'lg:pff-flexbox-row--start';
      }
    } else {
      return 'pff-flexbox-row--start';
    }
  }, [start]);

  const centerCssClass = useMemo(() => {
    if (!center) {
      return '';
    }

    const breakpointWidth = theme.screens[center];
    if (breakpointWidth) {
      if (center === DIMENSION.sm) {
        return 'sm:pff-flexbox-row--center';
      } else if (center === DIMENSION.md) {
        return 'md:pff-flexbox-row--center';
      } else if (center === DIMENSION.lg) {
        return 'lg:pff-flexbox-row--center';
      }
    } else {
      return 'pff-flexbox-row--center';
    }
  }, [center]);

  const endCssClass = useMemo(() => {
    if (!end) {
      return '';
    }

    const breakpointWidth = theme.screens[end];
    if (breakpointWidth) {
      if (end === DIMENSION.sm) {
        return 'sm:pff-flexbox-row--end';
      } else if (end === DIMENSION.md) {
        return 'md:pff-flexbox-row--end';
      } else if (end === DIMENSION.lg) {
        return 'lg:pff-flexbox-row--end';
      }
    } else {
      return 'pff-flexbox-row--end';
    }
  }, [end]);

  const topCssClass = useMemo(() => {
    if (!top) {
      return '';
    }

    const breakpointWidth = theme.screens[top];
    if (breakpointWidth) {
      if (top === DIMENSION.sm) {
        return 'sm:pff-flexbox-row--top';
      } else if (top === DIMENSION.md) {
        return 'md:pff-flexbox-row--top';
      } else if (top === DIMENSION.lg) {
        return 'lg:pff-flexbox-row--top';
      }
    } else {
      return 'pff-flexbox-row--top';
    }
  }, [top]);

  const middleCssClass = useMemo(() => {
    if (!middle) {
      return '';
    }

    const breakpointWidth = theme.screens[middle];
    if (breakpointWidth) {
      if (middle === DIMENSION.sm) {
        return 'sm:pff-flexbox-row--middle';
      } else if (middle === DIMENSION.md) {
        return 'md:pff-flexbox-row--middle';
      } else if (middle === DIMENSION.lg) {
        return 'lg:pff-flexbox-row--middle';
      }
    } else {
      return 'pff-flexbox-row--middle';
    }
  }, [middle]);

  const bottomCssClass = useMemo(() => {
    if (!bottom) {
      return '';
    }

    const breakpointWidth = theme.screens[bottom];
    if (breakpointWidth) {
      if (bottom === DIMENSION.sm) {
        return 'sm:pff-flexbox-row--bottom';
      } else if (bottom === DIMENSION.md) {
        return 'md:pff-flexbox-row--bottom';
      } else if (bottom === DIMENSION.lg) {
        return 'lg:pff-flexbox-row--bottom';
      }
    } else {
      return 'pff-flexbox-row--bottom';
    }
  }, [bottom]);

  const aroundCssClass = useMemo(() => {
    if (!around) {
      return '';
    }

    const breakpointWidth = theme.screens[around];
    if (breakpointWidth) {
      if (around === DIMENSION.sm) {
        return 'sm:pff-flexbox-row--around';
      } else if (around === DIMENSION.md) {
        return 'md:pff-flexbox-row--around';
      } else if (around === DIMENSION.lg) {
        return 'lg:pff-flexbox-row--around';
      }
    } else {
      return 'pff-flexbox-row--around';
    }
  }, [around]);

  const betweenCssClass = useMemo(() => {
    if (!between) {
      return '';
    }

    const breakpointWidth = theme.screens[between];
    if (breakpointWidth) {
      if (between === DIMENSION.sm) {
        return 'sm:pff-flexbox-row--between';
      } else if (between === DIMENSION.md) {
        return 'md:pff-flexbox-row--between';
      } else if (between === DIMENSION.lg) {
        return 'lg:pff-flexbox-row--between';
      }
    } else {
      return 'pff-flexbox-row--between';
    }
  }, [between]);

  const firstCssClass = useMemo(() => {
    if (!first) {
      return '';
    }

    const breakpointWidth = theme.screens[first];
    if (breakpointWidth) {
      if (first === DIMENSION.sm) {
        return 'sm:pff-flexbox-row--first';
      } else if (first === DIMENSION.md) {
        return 'md:pff-flexbox-row--first';
      } else if (first === DIMENSION.lg) {
        return 'lg:pff-flexbox-row--first';
      }
    } else {
      return 'pff-flexbox-row--first';
    }
  }, [first]);

  const lastCssClass = useMemo(() => {
    if (!last) {
      return '';
    }

    const breakpointWidth = theme.screens[last];
    if (breakpointWidth) {
      if (last === DIMENSION.sm) {
        return 'sm:pff-flexbox-row--last';
      } else if (last === DIMENSION.md) {
        return 'md:pff-flexbox-row--last';
      } else if (last === DIMENSION.lg) {
        return 'lg:pff-flexbox-row--last';
      }
    } else {
      return 'pff-flexbox-row--last';
    }
  }, [last]);

  const cssClass = useMemo(
    () =>
      clsx(
        'pff-flexbox-row',
        reverseCssClass,
        startCssClass,
        centerCssClass,
        endCssClass,
        topCssClass,
        middleCssClass,
        bottomCssClass,
        aroundCssClass,
        betweenCssClass,
        firstCssClass,
        lastCssClass,
        className,
      ),
    [
      reverseCssClass,
      startCssClass,
      centerCssClass,
      endCssClass,
      topCssClass,
      middleCssClass,
      bottomCssClass,
      aroundCssClass,
      betweenCssClass,
      firstCssClass,
      lastCssClass,
      className,
    ],
  );

  return (
    <div {...rowProps} className={cssClass} ref={ref}>
      {children}
    </div>
  );
});

Row.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  reverse: PropTypes.bool,
  start: ModificatorType,
  center: ModificatorType,
  end: ModificatorType,
  top: ModificatorType,
  middle: ModificatorType,
  bottom: ModificatorType,
  around: ModificatorType,
  between: ModificatorType,
  first: ModificatorType,
  last: ModificatorType,
};

export default Row;
